module.exports = __webpack_public_path__ + "img/03.94ee810c.jpg";